import type { FieldState } from '@tanstack/react-form';

import { useTranslation } from 'react-i18next';

type TanstackSkillIssue = any;

export function FieldInfo({
    state,
}: {
    state: FieldState<TanstackSkillIssue>;
}) {
    const { t } = useTranslation('common');

    if (state.meta.isTouched && state.meta.errors?.length) {
        return <em className="text-red-500">{state.meta.errors.join(',')}</em>;
    }

    if (state.meta.isValidating && import.meta.env.NODE_ENV === 'development') {
        return <em className="font-normal">{t('validating')}</em>;
    }

    return null;
}

export default FieldInfo;
